import { render, staticRenderFns } from "./onMounted-editor.vue?vue&type=template&id=479f4bf4&scoped=true&"
import script from "./onMounted-editor.vue?vue&type=script&lang=js&"
export * from "./onMounted-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479f4bf4",
  null
  
)

export default component.exports